import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PopulationService from "../../../Services/Population.service";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import LinkToPerson from "../Person/LinkToPerson/LinkToPerson";
const PAGE_SIZE = 20;
// @ts-expect-error dumb react typing -- will be fixed when we upgrade
const PersonPopulationMembersTable = ({ populationId, studentTempVals, }) => {
    const searchArgs = React.useMemo(() => ({ studentTempVals, populationId }), [populationId, studentTempVals]);
    const { table } = usePagedSortedTable({
        noDataComponent: "No people found in filter",
        searchArgs,
        addMarginToPager: true,
        getData: (sort, pageNumber, sArgs) => {
            var _a;
            return PopulationService.membersForPersonPopulation({
                populationId: sArgs.populationId,
                tempVals: (_a = sArgs.studentTempVals) !== null && _a !== void 0 ? _a : {},
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
            });
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "Id",
                size: 2,
            },
            {
                title: "Name",
                size: 3,
            },
            {
                title: "Email",
                size: 3,
            },
        ],
        rows: ({ data }) => data.map((person) => {
            return [
                _jsx(LinkToPerson, { target: "_blank", affiliationId: person.affiliationId, children: person.studentId }, 0),
                person.fullName,
                person.emailAddress,
            ];
        }),
    });
    return table;
};
export default PersonPopulationMembersTable;
